export default __webpack_public_path__ + "static/IBM-Plex-Mono-300-bdbb6d895bbfd517ce5b8592507b7971.woff";